module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "zk-select-group__wrap"
  }, [_c('li', {
    staticClass: "zk-select-group__title"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "zk-select-group"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-1307f5ac"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/select/src/option-group.vue
// module id = 234
// module chunks = 0